/** SARATTI high-value cart review and payment-assistance gate. */
(function (window, document) {
  'use strict';

  if (window.__sarattiPrivateReviewGateReady) return;
  window.__sarattiPrivateReviewGateReady = true;

  var currentCart = null;
  var reviewRequired = false;
  var refreshTimer = 0;
  var modal = null;
  var lastOpener = null;

  var checkoutSelector = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    'a[href*="/checkout"]',
    '[data-testid="Checkout-button"]'
  ].join(',');

  var acceleratedSelector = [
    '.additional-checkout-buttons',
    '.dynamic-checkout__content',
    '.cart__dynamic-checkout-buttons',
    '.cart-drawer__dynamic-checkout-buttons',
    '[data-shopify-buttoncontainer]',
    '.shopify-payment-button'
  ].join(',');

  function text(value) {
    return value == null ? '' : String(value).replace(/\s+/g, ' ').trim();
  }

  function rootUrl() {
    var root = window.Shopify && Shopify.routes && Shopify.routes.root || '/';
    return String(root).replace(/\/$/, '');
  }

  function hasPrivateReviewMarker(item) {
    var properties = item && item.properties || {};
    return text(properties['_Private Concierge Required']).toLowerCase() === 'yes' ||
      text(properties['_SARATTI Checkout Route']).toLowerCase() === 'private concierge';
  }

  function cartNeedsReview(cart) {
    return !!(cart && Array.isArray(cart.items) && cart.items.some(hasPrivateReviewMarker));
  }

  function itemSummary(item, index) {
    var properties = item.properties || {};
    var lines = [
      (index + 1) + '. ' + text(item.product_title || item.title),
      'Variant: ' + text(item.variant_title || 'Default'),
      'Quantity: ' + Number(item.quantity || 1)
    ];

    [
      'Setting', 'Center Stone', 'Selected Setting', 'Selected Gemstone',
      'Metal Type', 'Metal Color', 'Ring Size', 'Engraving',
      'Complimentary Ring Sizer', '_SARATTI Build ID'
    ].forEach(function (key) {
      if (text(properties[key])) lines.push(key.replace(/^_/, '') + ': ' + text(properties[key]));
    });

    return lines.join('\n');
  }

  function cartSummary(cart) {
    if (!cart || !Array.isArray(cart.items)) return 'Cart details unavailable.';
    return cart.items.map(itemSummary).join('\n\n');
  }

  function ensureModal() {
    if (modal) return modal;

    modal = document.createElement('div');
    modal.className = 'saratti-private-review-modal';
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML =
      '<button type="button" class="saratti-private-review-modal__shade" data-private-review-close aria-label="Close private review"></button>' +
      '<section class="saratti-private-review-modal__panel" role="dialog" aria-modal="true" aria-labelledby="saratti-private-review-title">' +
        '<button type="button" class="saratti-private-review-modal__close" data-private-review-close aria-label="Close private review">×</button>' +
        '<p class="saratti-private-review-modal__eyebrow">Private order review</p>' +
        '<h2 id="saratti-private-review-title">Complete your order with a SARATTI specialist.</h2>' +
        '<p class="saratti-private-review-modal__intro">Your selected ring remains safely in your cart. For orders above USD 10,000, our concierge confirms the details privately and assists with secure payment arrangements.</p>' +
        '<div class="saratti-private-review-modal__notice"><strong>No payment is taken through this form.</strong><br>Submit your details and our team will review the gemstone, setting, availability and final order information before contacting you.</div>' +
        '<form method="post" action="/contact#saratti-private-review-form" accept-charset="UTF-8" id="saratti-private-review-form">' +
          '<input type="hidden" name="form_type" value="contact">' +
          '<input type="hidden" name="utf8" value="✓">' +
          '<input type="hidden" name="contact[subject]" value="High-value ring builder private review">' +
          '<textarea name="contact[body]" data-private-review-body hidden></textarea>' +
          '<div class="saratti-private-review-modal__grid">' +
            '<label>First name *<input type="text" name="contact[first_name]" required autocomplete="given-name"></label>' +
            '<label>Last name *<input type="text" name="contact[last_name]" required autocomplete="family-name"></label>' +
            '<label>Email address *<input type="email" name="contact[email]" required autocomplete="email"></label>' +
            '<label>Phone / WhatsApp *<input type="tel" name="contact[phone]" required autocomplete="tel"></label>' +
            '<label>Country / Region *<input type="text" name="contact[country]" required autocomplete="country-name"></label>' +
            '<label>Preferred contact<select name="contact[preferred_contact]"><option>Email</option><option>WhatsApp</option><option>Phone call</option></select></label>' +
          '</div>' +
          '<label>Anything you would like us to know<textarea name="contact[customer_note]" data-private-review-note placeholder="Delivery timing, questions, requested adjustments, or the best time to contact you."></textarea></label>' +
          '<button class="saratti-private-review-modal__submit" type="submit">SEND FOR PRIVATE REVIEW</button>' +
        '</form>' +
      '</section>';

    document.body.appendChild(modal);

    modal.addEventListener('click', function (event) {
      if (event.target.closest('[data-private-review-close]')) {
        event.preventDefault();
        closeModal();
      }
    });

    modal.querySelector('form').addEventListener('submit', function () {
      var body = modal.querySelector('[data-private-review-body]');
      var note = modal.querySelector('[data-private-review-note]');
      var preferred = modal.querySelector('select[name="contact[preferred_contact]"]');
      var country = modal.querySelector('input[name="contact[country]"]');
      body.value = [
        'PRIVATE ORDER REVIEW — RING BUILDER',
        '',
        'Preferred contact: ' + text(preferred && preferred.value),
        'Country / Region: ' + text(country && country.value),
        'Customer note: ' + (text(note && note.value) || 'None'),
        '',
        'CART SELECTION',
        cartSummary(currentCart),
        '',
        'Cart URL: ' + window.location.origin + rootUrl() + '/cart'
      ].join('\n');
    });

    return modal;
  }

  function openModal(opener) {
    lastOpener = opener || null;
    var dialog = ensureModal();
    dialog.classList.add('is-open');
    dialog.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('saratti-private-review-lock');
    document.body.classList.add('saratti-private-review-lock');
    window.setTimeout(function () {
      var first = dialog.querySelector('input:not([type="hidden"])');
      if (first) first.focus();
    }, 30);
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('saratti-private-review-lock');
    document.body.classList.remove('saratti-private-review-lock');
    if (lastOpener && lastOpener.focus) lastOpener.focus();
  }

  function ensureReviewButton(original) {
    var parent = original.parentElement;
    if (!parent) return;
    var existing = parent.querySelector(':scope > .saratti-private-review-trigger');
    if (!existing) {
      existing = document.createElement('button');
      existing.type = 'button';
      existing.className = 'saratti-private-review-trigger';
      existing.textContent = 'SUBMIT FOR PRIVATE REVIEW';
      original.insertAdjacentElement('afterend', existing);

      var note = document.createElement('p');
      note.className = 'saratti-private-review-note';
      note.textContent = 'Orders above USD 10,000 are reviewed privately before payment.';
      existing.insertAdjacentElement('afterend', note);
    }
  }

  function removeReviewButtons() {
    document.querySelectorAll('.saratti-private-review-trigger, .saratti-private-review-note').forEach(function (node) {
      node.remove();
    });
  }

  function applyGate() {
    document.body.classList.toggle('saratti-private-review-required', reviewRequired);

    document.querySelectorAll(checkoutSelector).forEach(function (control) {
      if (control.closest('.saratti-private-review-modal')) return;
      if (reviewRequired) {
        control.classList.add('saratti-private-review-hidden');
        control.setAttribute('aria-hidden', 'true');
        ensureReviewButton(control);
      } else {
        control.classList.remove('saratti-private-review-hidden');
        control.removeAttribute('aria-hidden');
      }
    });

    document.querySelectorAll(acceleratedSelector).forEach(function (container) {
      container.classList.toggle('saratti-private-review-hidden', reviewRequired);
      if (reviewRequired) container.setAttribute('aria-hidden', 'true');
      else container.removeAttribute('aria-hidden');
    });

    if (!reviewRequired) removeReviewButtons();
  }

  function syncCart(cart) {
    currentCart = cart || null;
    reviewRequired = cartNeedsReview(cart);
    applyGate();
  }

  function fetchCart() {
    return fetch(rootUrl() + '/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to read cart.');
      return response.json();
    }).then(syncCart).catch(function (error) {
      console.error('SARATTI private review cart check:', error);
    });
  }

  function scheduleCartCheck(delay) {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(fetchCart, delay || 0);
  }

  window.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('.saratti-private-review-trigger');
    if (trigger) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openModal(trigger);
      return;
    }

    var checkout = event.target.closest && event.target.closest(checkoutSelector);
    if (reviewRequired && checkout) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openModal(checkout);
    }
  }, true);

  document.addEventListener('submit', function (event) {
    if (!reviewRequired) return;
    var submitter = event.submitter;
    var checkoutSubmit = submitter && submitter.matches && submitter.matches(checkoutSelector);
    var checkoutForm = event.target && /\/checkout(?:\?|$)/.test(event.target.action || '');
    if (!checkoutSubmit && !checkoutForm) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    openModal(submitter || event.target);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeModal();
  });

  ['on:cart:add', 'on:line-item:change', 'dispatch:cart-drawer:refresh', 'on:cart-drawer:after-open', 'on:bfcache:load-restore'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      if (event.detail && event.detail.cart) syncCart(event.detail.cart);
      else scheduleCartCheck(80);
    });
  });

  new MutationObserver(function () {
    window.requestAnimationFrame(applyGate);
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetchCart, { once: true });
  } else {
    fetchCart();
  }
})(window, document);
